import {
  EKPAY_PAYMENT_VERIFY,
  PAYMENT_RESPONSE,
  PAYMENT_STATUS,
} from "../constants";
import { apiSlice } from "./apiSlice";

const paymentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    paymentResponse: builder.query({
      query: ({ status, transId }) =>
        PAYMENT_RESPONSE + "/" + status + "?transId=" + transId,
    }),
    paymentStatus: builder.query({
      query: (transaction_id) => PAYMENT_STATUS + "/" + transaction_id,
    }),
    // EKPAY_PAYMENT_VERIFY
    ekpayPaymentVerify: builder.mutation({
      query: (body) => ({
        url: EKPAY_PAYMENT_VERIFY,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  usePaymentResponseQuery,
  usePaymentStatusQuery,
  useEkpayPaymentVerifyMutation,
} = paymentApiSlice;
